/** @format */

const discoveryDustLogs = {
  // discovery 曝光
  discoveryPageShowLog: {
    event: 'page_show',
    params: {
      page: 'discovery',
    },
  },
};

export default discoveryDustLogs;
